/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */

import { isGeotabMode } from '@/services/geotabSession'

const { VITE_FRESH_LEGACY_URL } = import.meta.env

/**
 * Whether to offer the link to the legacy Fresh app. Hidden as a MyGeotab add-in: it opens
 * the legacy Fresh app in a new tab, which takes the user out of MyGeotab entirely and into
 * a separate login.
 */
export const canOpenFresh = (isAuthenticated: boolean): boolean =>
  isAuthenticated && Boolean(VITE_FRESH_LEGACY_URL) && !isGeotabMode()

/** Opens Fresh in its own named tab, or brings that tab forward if it's already open. */
export const redirectToLegacyFresh = () => {
  if (!VITE_FRESH_LEGACY_URL) return

  const newWindow = window.open('', 'refreshInsightsTab')
  if (newWindow?.location.href === 'about:blank') {
    newWindow.location.href = VITE_FRESH_LEGACY_URL
  } else {
    newWindow?.focus()
  }
}
